import { useAppDispatch, useAppSelector } from "core/utils";
import type { FC } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router";

import type { NoneOwnProps } from "../../types";
import { authActions } from "./actions";
import { getRedirect } from "./selectors";

export const RedirectProvider: FC<NoneOwnProps> = () => {
    const redirect = useAppSelector(getRedirect);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (redirect) {
            navigate(redirect);
            dispatch(authActions.clearRedirect()); // Clear after navigating
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [redirect]);

    return null;
};
